import api from 'api';

export const reassignCharitiesByAccessToken = ({ charitiesIds }: { charitiesIds: string }) => {
   return api.post(`/v1/users/me/charities/ids=${charitiesIds}`);
};
export const getImpactReportsByCharitiesIds = ({ charitiesIds }: { charitiesIds: string }) => {
   return api.get(`/v1/impactReport/charitiesIds=${charitiesIds}`);
};
